export default "__VITE_ASSET__BkULqC9j__"